// extracted by mini-css-extract-plugin
export default {"coverLink":"qZ-z","contentBox":"rZ-z","zapposPromoContainer":"sZ-z","zapposPromoGroupContainer":"tZ-z","promos":"uZ-z","bottom":"vZ-z","top":"wZ-z","right":"xZ-z","left":"yZ-z"};